<template>
  <BaseDialogForm
    v-model="showItemUnitForm"
    :title="editMode ? 'Edit Item Unit' : 'Add Item Unit'"
    :nonFieldErrors="formErrors.non_field_errors"
  >
    <template #content>
      <v-form
        v-model="isValid"
        ref="itemUnitForm"
        :key="formCount"
        @submit.prevent="submitForm"
      >
        <v-row class="ma-0">
          <v-col cols="4">
            <InputField
              v-model="itemUnitDetails.name"
              name="name"
              label="Name"
              :required="true"
              :error-messages="formErrors.name"
              @input="delete formErrors.name"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #actions>
      <v-btn
        color="secondary"
        depressed
        v-if="!editMode"
        @click="resetForm()"
        class="mr-3 white--text"
      >
        Reset
      </v-btn>
      <v-btn
        color="primary"
        depressed
        @click="submitForm()"
        :disabled="!isValid"
      >
        Submit
      </v-btn>
    </template>
  </BaseDialogForm>
</template>

<script>
import { bus } from "@/main.js";
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";

export default {
  components: { BaseDialogForm },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      required: true,
    },
    itemUnitID: {
      type: Number,
    },
  },
  data() {
    return {
      fileInput: null,
      formCount: 0,
      isValid: true,
      itemUnitDetails: {},
      formErrors: {},
      unitList: [],
    };
  },
  watch: {
    value(val) {
      if (val) {
        if (this.editMode && this.itemUnitID) {
          this.getItemUnitObject(this.itemUnitID);
        }
      } else {
        this.resetForm();
        this.formErrors = {};
      }
    },
  },
  computed: {
    showItemUnitForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    resetForm() {
      this.itemUnitDetails = {};
      this.$refs.itemUnitForm.reset();
    },
    getItemUnitObject(id) {
      this.$api.itemUnit
        .getItemUnitObject(id)
        .then((res) => {
          this.itemUnitDetails = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submitForm() {
      if (!this.$refs.itemUnitForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }
      if (this.editMode) {
        this.$api.itemUnit
          .updateItemUnitObject({
            id: this.itemUnitDetails.id,
            data: this.itemUnitDetails,
          })
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Item Unit information updated!",
              color: "success",
            });
            this.$emit("refreshList");
            this.showItemUnitForm = false;
          })
          .catch((err) => {
            console.log(err);
            this.formErrors = err.data;
          });
      } else {
        this.$api.itemUnit
          .createItemUnitObject(this.itemUnitDetails)
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Item Unit created!",
              color: "success",
            });
            this.showItemUnitForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.formErrors = err.data;
          });
      }
    },
  },
  mounted() {
    if ("id" in this.$route.params) {
      this.getItemUnitObject(this.$route.params.id);
    }
  },
};
</script>

<style>
.v-select__slot label {
  z-index: 2;
}
</style>
